import Ajax from '@/lib/ajax'

export default {
    edit(id: string | number, editData: any) {
      let ajaxType = id ? 'put' : 'post'
      let ajaxUrl = id
        ? `/api/MallConfigManagement/PCHomeTemplate?id=${id}`
        : '/api/MallConfigManagement/PCHomeTemplate'
      return Ajax[ajaxType](ajaxUrl, editData)
    },
    getFloorDataById(id: string) {
      return Ajax.get(`/api/MallConfigManagement/PCHome/${id}`)
    },
    editFloor(id: string | number, editData: any) {
      let ajaxType = id ? 'put' : 'post'
      let ajaxUrl = id
        ? `/api/MallConfigManagement/PCHome?id=${id}`
        : '/api/MallConfigManagement/PCHome'
      return Ajax[ajaxType](ajaxUrl, editData)
    },
    copyTemplate(id: string) {
      return Ajax.post(`/api/MallConfigManagement/PCHomeTemplate/ByCopy?id=${id}`)
    },
    /**
     * 获取首页模板详情
     */
    getPCHomeTemplateDetail(id: string) {
      return Ajax.get(`/api/MallConfigManagement/PCHome/Template/${id}`)
    },
    /**
     * 新增首页模板
     */
    createPCHomeTemplate(obj: any) {
      return Ajax.post(`/api/MallConfigManagement/PCHome/CreateTemplate`, obj)
    },
    /**
     * 修改首页模板
     */
    updatePCHomeTemplate(id: string, obj: any) {
      return Ajax.put(`/api/MallConfigManagement/PCHome/UpdateTemplate/${id}`, obj)
    }
}